export default __webpack_public_path__ + "assets/small-pin.425ccdd3.svg";